import { unstable_serialize } from "swr";
import query from "utils/query";
import Config from "components/config";
import CompanyDetails from "components/companies/company-detail";

// used for get static props
import COMPANY_QUERY from "queries/company";

export default function Company({ fallback }) {
  return (
    <Config fallback={fallback}>
      <CompanyDetails />
    </Config>
  );
}

export async function getStaticPaths() {
  // We'll build some of the top companies
  const slugs = [
    "cedar-fair",
    "disney",
    "merlin-entertainments",
    "sea-world",
    "six-flags",
    "universal-studios",
  ];

  const paths = slugs.map((slug) => ({
    params: { company: slug },
  }));

  return { paths, fallback: "blocking" };
}

export async function getStaticProps({ params }) {
  const fallback = {};

  const variables = {
    slug: params.company,
  };

  const data = await Promise.all([query(COMPANY_QUERY, variables)]);

  fallback[[unstable_serialize([COMPANY_QUERY, variables])]] = data[0];

  return {
    props: {
      fallback,
    },
  };
}
